<template>
  <div>
    <div class="container-fluid">
      <div class="row orta">
        <div class="col-md-9">
          <vx-card>
            <vs-row>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="12"
                vs-sm="12"
                vs-md="12"
              >
                <h3>{{ $t('addMachine') }}</h3>
              </vs-col>
            </vs-row>
            <vs-row>
              <vs-col
                vs-type="flex"
                vs-justify="flex-start"
                vs-align="flex-start"
                vs-lg="6"
                vs-sm="6"
                vs-md="6"
              >
                <vs-button class="ml-5" icon="arrow_back" to="/machines">{{ $t('back') }}</vs-button>
              </vs-col>

              <vs-col
                vs-type="flex"
                vs-justify="flex-end"
                vs-align="flex-end"
                vs-lg="6"
                vs-sm="6"
                vs-md="6"
              >
                <vs-button
                  class="mr-5"
                  icon="save"
                  :disabled="!validateForm"
                  @click="addMachine"
                >{{ $t('save') }}</vs-button>
              </vs-col>
            </vs-row>

            <div class="vx-row justify-content-center">
              <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-3">
                <v-select
                  :placeholder="$t('selectUser')"
                  :name="$t('selectUser')"
                  v-validate="'required'"
                  class="w-full mt-6"
                  :closeOnSelect="true"
                  label="userName"
                  v-model="machine.UserId"
                  :options="users"
                  :reduce="users => users.id"
                />
                <span class="text-danger text-sm">{{ errors.first($t('selectUser')) }}</span>
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-3">
                <vs-input
                  v-validate="'required'"
                  :name="$t('machineName')"
                  :label-placeholder="$t('machineName')"
                  v-model="machine.MachineName"
                  class="w-full mt-6"
                />
                <span class="text-danger text-sm">{{ errors.first($t('machineName')) }}</span>
              </div>
            </div>
            <div class="vx-row justify-content-center">
              <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-3">
                <vs-input
                  :label-placeholder="$t('teamViewerId')"
                  v-model="machine.TeamViewerId"
                  class="w-full mt-6"
                />
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-3">
                <vs-input
                  :label-placeholder="$t('teamViewerPassword')"
                  v-model="machine.TeamViewerPassword"
                  class="w-full mt-6"
                />
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-3">
                <vs-input
                  :label-placeholder="$t('anydDeskId')"
                  v-model="machine.AnyDeskId"
                  class="w-full mt-6"
                />
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-3">
                <vs-input
                  :label-placeholder="$t('anyDeskPassword')"
                  v-model="machine.AnyDeskPassword"
                  class="w-full mt-6"
                />
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import http from "../../../http/http-helper";
import notify from "../../../shared/toast";

export default {
  computed: {
    validateForm() {
      return (
        !this.errors.any() &&
        this.machine.MachineName != "" &&
        this.machine.UserId != ""
      );
    }
  },
  data() {
    return {
      users: [],
      machine: {
        UserId: "",
        MachineName: "",
        TeamViewerId: "",
        TeamViewerPassword: "",
        AnyDeskId: "",
        AnyDeskPassword: ""
      }
    };
  },
  methods: {
    getUsers() {
      let path = "/users/getlist";
      http.get(path).then(response => {
        this.users = response.map(u => {
          return {
            id: u.id,
            userName: u.userName
          };
        });
      });
    },
    addMachine() {
      let path = "/machines/add";
      http.post(path, this.machine).then(response => {
        this.machine.MachineName = "";
        this.machine.TeamViewerId = "";
        this.machine.TeamViewerPassword = "";
        this.machine.AnyDeskId = "";
        this.machine.AnyDeskPassword = "";
        notify.success(this.$t("saved"), response.message);
        this.$router.push("/machines");
      });
    }
  },
  created() {
    this.getUsers();
  }
};
</script>
<style scoped>
.orta {
  display: flex;
  justify-content: center;
}
</style>